import { useEffect } from "react";

import { ReceivingInvoiceDetailsViewModel } from "../../../../viewmodels/receiving/invoices/details/ReceivingInvoiceDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import { withRouter } from "../../../../shared/utility";

import SlideOver from "../../../../components/slideOver/SlideOver";
import AddReceivingInvoiceForm from "../../../../components/forms/receiving/invoices/AddReceivingInvoiceForm";
import { useParams } from "react-router-dom";
import EmptyModal from "../../../../components/modals/EmptyModal";

function ReceivingInvoiceDetails(props) {
  const { addSnackbar, logout } = props;

  const { invoiceId } = useParams();

  const {
    addItemToReceivingInvoice,
    barcodeDetails,
    createReceivingInvoice,
    getAllAssemblyItems,
    getAssemblyItemByPlu,
    invoice,
    invoiceItems,
    setInvoiceItems,
    onGenerateBarcodePdf,
    loading,
    setSlideOver,
    slideOver,
    getReceivingInvoiceDetails,
    updateReceivingInvoiceApiCall,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    openReceivingItemDetails,
    deleteReceivingItem,
    deleteMultipleReceivingItems,
    getEmployeesForDropdown,
    employeeOptions,
    suppliers,
    getSuppliersForDropdown,
    printReceivingReportByID,
    getInvoiceProducts,
    getInvoiceLots,
    getInvoiceLotItems,
    lotsLoading,
    itemsLoading,
  } = ReceivingInvoiceDetailsViewModel(logout, invoiceId, addSnackbar);

  useEffect(() => {
    getEmployeesForDropdown();
    getReceivingInvoiceDetails();
    getInvoiceProducts();
    getSuppliersForDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {invoice.id > 0 ? (
          <AddReceivingInvoiceForm
            addItemToReceivingInvoice={addItemToReceivingInvoice}
            barcodeDetails={barcodeDetails}
            createReceivingInvoice={createReceivingInvoice}
            invoice={invoice}
            isEdit={true}
            onGenerateBarcodePdf={onGenerateBarcodePdf}
            getAllAssemblyItems={getAllAssemblyItems}
            getAssemblyItemByPlu={getAssemblyItemByPlu}
            setSlideOver={setSlideOver}
            invoiceItems={invoiceItems}
            setInvoiceItems={setInvoiceItems}
            updateReceivingInvoiceApiCall={updateReceivingInvoiceApiCall}
            showErrorModal={showErrorModal}
            openReceivingItemDetails={openReceivingItemDetails}
            deleteReceivingItem={deleteReceivingItem}
            deleteMultipleReceivingItems={deleteMultipleReceivingItems}
            setEmptyModelOpen={setEmptyModelOpen}
            employeeOptions={employeeOptions}
            suppliers={suppliers}
            printReceivingReportByID={printReceivingReportByID}
            getInvoiceProducts={getInvoiceProducts}
            getInvoiceLots={getInvoiceLots}
            getInvoiceLotItems={getInvoiceLotItems}
            lotsLoading={lotsLoading}
            itemsLoading={itemsLoading}
          />
        ) : null}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass="max-w-3xl"
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReceivingInvoiceDetails),
);
